import React, { useState, useEffect, useRef } from "react";
import "./ProfessorInsights.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Button } from "react-bootstrap";
import Spinner from "../Spinner/Spinner";
import { withRouter } from "react-router";
import { Tabs, Tab } from "react-bootstrap";
import { withAuth } from "../../app/util/HOC";
import FormControl from "react-bootstrap/FormControl";
import { handleException } from "../../app/util/util";
import loaderColors1 from "../Spinner/loaderColors1.gif";
export function ProfessorInsights(props) {
  let uploadFile = () => uploadFile.bind();
  let createClassClick = () => createClassClick.bind();
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const bookVOInfo = JSON.parse(localStorage.getItem("bookVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [bookVO, setBookVO] = useState({});
  const [classId, setClassId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [EnableEdit, setEnableEdit] = useState(false);
  const [createClass, setCreateClass] = useState(false);
  const [cancelClass, setCancelClass] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [state, setState] = useState({ classVOList: [] });
  const [addClassState, setaddClassState] = useState(false);
  const fileInputRefs = useRef(
    Array(0)
      .fill(null)
      .map(() => React.createRef()),
  );
  const classInfoTabError = useRef(null);
  useEffect(() => {
    getClassDetails();
    document.title = `${bookVOInfo && bookVOInfo.bookTitle !== undefined ? bookVOInfo.bookTitle : ""} | Insights | Aspen Publishing`;
  }, []);
  const getClassDetails = () => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingTo: "ClassInsight",
          pageNavigatingFrom: "ClassInsight",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      classVO: {
        bookISBN: props.match.params.isbn,
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    setLoading(true);
    fetch(
      localStorage.getItem("ENV") + "/manageClassWebService/getClassDetailsRV",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === "true") {
          setBookVO(data.bookVO);
          if (data.classVOList) {
            var classVOList = Array.isArray(data.classVOList)
              ? data.classVOList
              : [data.classVOList];
            for (var i = 0; i < classVOList.length; i++) {
              if (classVOList[i].fileList)
                classVOList[i].fileList = Array.isArray(classVOList[i].fileList)
                  ? classVOList[i].fileList
                  : [classVOList[i].fileList];
            }
            updateClassFileRefs(classVOList.length);
            setState({ ...state, classVOList: classVOList });
          }
          setLoading(false);
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const updateClassFileRefs = (classVoLen) => {
    const newRefs = Array(classVoLen)
      .fill(null)
      .map(() => React.createRef());
    fileInputRefs.current = newRefs;
  };
  createClassClick = (e) => {
    setCreateClass(true);
    const creaClassName = document.getElementById("className").value;
    if (creaClassName && creaClassName.trim().length > 0) {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadPageNum: "",
            lastViewedOutlineId: 2,
            lastReadSectionId: "sec01",
            lastReadChapterId: "chap01",
            lastReadParagraphId: "para01",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingTo: "ClassInsight",
            lastReadSubSectionId: "subsec01",
            pageNavigatingFrom: "ClassInsight",
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
        },
        classVO: {
          section: "",
          meetingTime: "",
          semesterYear: "",
          bookISBN: props.match.params.isbn,
          className: document.getElementById("className").value,
          classDescription: document.getElementById("classDescription").value,
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        localStorage.getItem("ENV") + "/manageClassWebService/addClass",
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.status === "true") {
            var classList = state.classVOList;
            classList.unshift(data.classVO);
            setState({ ...state, errorInvalideClassCodeMsg: "" });
            updateClassFileRefs(classList.length);
            setState({ ...state, classVOList: classList });
            setaddClassState(false);
          } else if (data.wkErrorCode) {
            if (data.wkErrorCode === "bus.exception.class.name.exists")
              setState({
                ...state,
                errorInvalideClassCodeMsg:
                  "Error: You already have a class with this name in your account. Try another.",
              });
            else handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    } else {
      setState({
        ...state,
        errorInvalideClassCodeMsg: "Error: Class name is required.",
      });
      classInfoTabError.current.focus();
    }
  };
  const addClassClick = () => {
    setCancelClass(false);
    setaddClassState(true);
  };
  const CancelClick = (e) => {
    setEnableEdit(false);
    setEditMode(false);
    setCancelClass(true);
    setaddClassState(false);
    const docEleIndex = e.target.getAttribute("index");
    if (docEleIndex) {
      disableClassEdit(docEleIndex);
      var Edirbtn = document.getElementById(`editBtn${docEleIndex}`);
      Edirbtn.style.background = "none";
      Edirbtn.style.color = "#FFFFFF";
      Edirbtn.focus();
      var labelEnrolledStudents = document.getElementById(
        `labelEnrolledStudents${docEleIndex}`,
      );
      labelEnrolledStudents.classList.remove("display-none");
    }
  };
  const enableClassEdit = (e) => {
    setClassId(e.target.getAttribute("classId"));
    setEnableEdit(true);
    e.target.style.background = "#FFFFFF";
    e.target.style.color = "#007AC3";
    const docEleIndex = e.target.getAttribute("index");
    var editableButton = document.getElementById(
      `editableButton${docEleIndex}`,
    );
    var editableSection = document.getElementById(
      `editClassSection${docEleIndex}`,
    );
    var classLabelSection = document.getElementById(
      `classLabelSection${docEleIndex}`,
    );
    var classNameLabelSection = document.getElementById(
      `classNameLabelSection${docEleIndex}`,
    );
    var labelEnrolledStudents = document.getElementById(
      `labelEnrolledStudents${docEleIndex}`,
    );
    if (editableSection) {
      editableButton.classList.remove("display-none");
      classLabelSection.classList.add("display-none");
      editableSection.classList.remove("display-none");
      classNameLabelSection.classList.add("display-none");
      labelEnrolledStudents.classList.add("display-none");
    }
  };
  const updateClass = (e) => {
    setEnableEdit(false);
    var docEleIndex = e.target.getAttribute("index");
    const updatedClassName = document.getElementById(
      `editClassName${docEleIndex}`,
    ).value;
    if (updatedClassName && updatedClassName.trim().length > 0) {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastActivityCode: "BOOKSHELF",
            pageNavigatingTo: "ClassInsight",
            pageNavigatingFrom: "ClassInsight",
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
        },
        classVO: {
          section: "",
          meetingTime: "",
          semesterYear: "",
          bookISBN: props.match.params.isbn,
          classId: e.target.getAttribute("classId"),
          className: document.getElementById(`editClassName${docEleIndex}`)
            .value,
          classDescription: document.getElementById(
            `editClassDescription${docEleIndex}`,
          ).value,
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        localStorage.getItem("ENV") + "/manageClassWebService/editClass",
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.status === "true") {
            document.getElementById(
              `labelClassDescription${docEleIndex}`,
            ).textContent = document.getElementById(
              `editClassDescription${docEleIndex}`,
            ).value;
            document.getElementById(
              `labelClassNameValue${docEleIndex}`,
            ).textContent = document.getElementById(
              `editClassName${docEleIndex}`,
            ).value;
            document.getElementById(`errorMsg_${docEleIndex}`).textContent = "";
            disableClassEdit(docEleIndex);
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    } else {
      document.getElementById(`errorMsg_${docEleIndex}`).textContent =
        "Error: Class name is required.";
    }
    var Edirbtn = document.getElementById(`editBtn${docEleIndex}`);
    Edirbtn.style.background = "none";
    Edirbtn.style.color = "#FFFFFF";
    Edirbtn.focus();
  };
  const deleteClass = (e) => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "class-insight",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      classVO: {
        bookISBN: props.match.params.isbn,
        classId: e.target.getAttribute("classId"),
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      localStorage.getItem("ENV") + "/manageClassWebService/deleteClass",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === "true") {
          var classList = state.classVOList.filter(function (obj) {
            return obj.classId !== e.target.getAttribute("classId");
          });
          updateClassFileRefs(classList.length);
          setState({ ...state, classVOList: classList });
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const disableClassEdit = (index) => {
    var editableButton = document.getElementById(`editableButton${index}`);
    var editableSection = document.getElementById(`editClassSection${index}`);
    var classLabelSection = document.getElementById(
      `classLabelSection${index}`,
    );
    var classNameLabelSection = document.getElementById(
      `classNameLabelSection${index}`,
    );
    var labelEnrolledStudents = document.getElementById(
      `labelEnrolledStudents${index}`,
    );
    if (editableSection) {
      editableButton.classList.add("display-none");
      editableSection.classList.add("display-none");
      classLabelSection.classList.remove("display-none");
      classNameLabelSection.classList.remove("display-none");
      labelEnrolledStudents.classList.remove("display-none");
    }
  };
  uploadFile = (event) => {
    if (event.target.files[0]) {
      setUploadedFile(event.target.files[0]);
      const docEleIndex = event.target.getAttribute("index");
      if (docEleIndex) {
        var uploadButton = document.getElementById(`uploadFile_${docEleIndex}`);
        uploadButton.focus();
      }
      var file = event.target.files[0];
      var data = new FormData();
      data.append("formData", file);
      data.append("userId", userVO.userId);
      data.append("userRole", userVO.userRole);
      data.append("userRoleId", userVO.userRoleId);
      data.append("appType", "web");
      data.append("deviceType", localStorage.getItem("deviceType"));
      data.append("deviceOS", localStorage.getItem("deviceOS"));
      data.append(
        "sessionAuthenticationToken",
        userVO.sessionAuthenticationToken,
      );
      data.append("classId", event.target.getAttribute("classid"));
      data.append("fileUploadPurpose", "Others");
      var classList = state.classVOList;
      fetch(
        localStorage.getItem("ENV") +
          "/manageClassWebService/uploadFileForClass",
        { method: "POST", body: data },
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            for (var i = 0; i < classList.length; i++) {
              if (
                event.target.getAttribute("classid") === classList[i].classId
              ) {
                if (data.fileVOList) {
                  var fileList = Array.isArray(data.fileVOList)
                    ? data.fileVOList
                    : [data.fileVOList];
                  classList[i].fileList = fileList;
                }
              }
            }
            updateClassFileRefs(classList.length);
            setState({ ...state, classVOList: classList });
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const deleteFile = (e) => {
    if (
      e.target.getAttribute("fileId") &&
      e.target.getAttribute("classId") &&
      e.target.getAttribute("fileName")
    ) {
      var classList = state.classVOList;
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "class-insight",
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
        },
        classVO: {
          bookISBN: props.match.params.isbn,
          classId: e.target.getAttribute("classId"),
        },
        fileVO: {
          fileId: e.target.getAttribute("fileId"),
          fileName: e.target.getAttribute("fileName"),
        },
      };
      const requestOptions1 = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(reqData),
      };
      fetch(
        localStorage.getItem("ENV") + "/manageClassWebService/deleteClassFile",
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            if (data) {
              for (var i = 0; i < classList.length; i++) {
                if (e.target.getAttribute("classId") === classList[i].classId) {
                  if (data.fileVOList) {
                    var fileList = Array.isArray(data.fileVOList)
                      ? data.fileVOList
                      : [data.fileVOList];
                    classList[i].fileList = fileList;
                  } else {
                    classList[i].fileList = [];
                  }
                }
              }
              updateClassFileRefs(classList.length);
              setState({ ...state, classVOList: classList });
            }
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const toggleClassList = (e) => {
    if (e.target.textContent === "Expand Class List")
      e.target.textContent = "Collapse Class List";
    else if (e.target.textContent === "Collapse Class List")
      e.target.textContent = "Expand Class List";
  };
  const handleDocKeyPress = (e, i) => {
    if (e.key === "Enter") {
      fileInputRefs.current[i].current.click(); // Trigger a click on the specific file input
    }
  };
  return (
    <React.Fragment>
      <Header userVO={userVO} bookVO={bookVO} pageName="insights"></Header>
      <Spinner
        loading={loading}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
        label="Loading insights section"
      />
      <div className="col-lg-12 insightsContainer">
        <div className="row greyDiv">
          <div className="col-lg-10 headingDiv">
            <span className="insightProperty">
              {bookVO ? (bookVO.bookTitle ? bookVO.bookTitle : "") : ""}
            </span>
            <br />
            <span className="insightHeading">Class Information</span>
          </div>
        </div>
        <br />
        <div className="insightTabDiv col-lg-8 col-md-8 col-sm-8 col-xs-12">
          <Tabs id="insight-tab">
            <Tab eventKey="classInformation" title="Class Information">
              {addClassState === true || state.classVOList.length === 0 ? (
                <div>
                  <br />
                  <span className="pText commonTabInfoText mTopTwnty">
                    Create a class for students to enroll in to share documents
                    and track reading analytics.{" "}
                  </span>
                  <br /> <br />
                  <div className="mainDiv">
                    <div style={{ padding: "1%" }}>
                      {state.errorInvalideClassCodeMsg ? (
                        <div
                          id="classInfoTabErrorMsg"
                          className="error-colorCode"
                          style={{ padding: "0px" }}
                        >
                          {state.errorInvalideClassCodeMsg}
                        </div>
                      ) : null}
                      <span className="iconText">Class Name</span>
                      <br />
                      <FormControl
                        data-testid="input_class_name"
                        id="className"
                        ref={classInfoTabError}
                        aria-label="Class Name"
                        aria-describedby="classInfoTabErrorMsg"
                        className="createClassName_rt"
                      />
                      <br />
                      <span className="iconText">Class Description</span>
                      <br />
                      <FormControl
                        data-testid="input_class_description"
                        id="classDescription"
                        aria-label="Class Description"
                        aria-describedby="basic-addon2"
                        className="classDiscription_rt"
                      />
                      {editMode == true ? (
                        <div className="row">
                          <div className="col-lg-3">
                            <Button
                              variant="outline-secondary"
                              className="enrollButton"
                            >
                              Save Changes
                            </Button>
                            <Button
                              variant="outline-secondary"
                              className="enrollButton"
                              onClick={CancelClick}
                            >
                              Cancel
                            </Button>
                          </div>
                          <div className="col-lg-3">
                            <Button
                              variant="outline-secondary"
                              className="enrollButton"
                            >
                              Delete Class
                            </Button>
                          </div>
                          <div className="col-lg-3">
                            <Button
                              variant="outline-secondary"
                              className="enrollButton"
                            >
                              Hide Class
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="pt-2">
                          <Button
                            className="enrollButton createClassBtn_rt ml-0"
                            onClick={createClassClick}
                          >
                            Create Class
                          </Button>
                          <Button
                            className="enrollButton cancelClassBtn_rt mLeftTen"
                            onClick={CancelClick}
                          >
                            Cancel
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              <div>
                <br />
                {addClassState === false &&
                state.classVOList &&
                state.classVOList.length > 0 ? (
                  <div>
                    <span className="pText commonTabInfoText mTopTwnty">
                      Create a class for students to enroll in to share
                      documents and track reading analytics.{" "}
                    </span>
                    <br /> <br />
                    <Button className="enrollButton" onClick={addClassClick}>
                      Add a Class
                    </Button>
                    <br /> <br />
                  </div>
                ) : null}
                {state.classVOList
                  ? state.classVOList.map((classObj, index) => (
                      <div>
                        <div className="mainDiv" style={{ marginTop: "1%" }}>
                          <div className="propertyFallDiv col-12">
                            <span
                              className="fallText"
                              id={`labelClassName${index}`}
                              style={{ float: "left" }}
                            >
                              Class Code: {classObj.classCode}
                            </span>
                            <div
                              className="classBtnsDiv"
                              style={{ float: "right" }}
                            >
                              <button
                                className="propertyButton mr-2"
                                id={`copyClassCodeBtn${index}`}
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    classObj.classCode,
                                  );
                                }}
                              >
                                Copy Code
                              </button>
                              <button
                                className="propertyButton"
                                id={`editBtn${index}`}
                                index={index}
                                classId={classObj.classId}
                                onClick={enableClassEdit}
                              >
                                Edit Class
                              </button>
                            </div>
                          </div>
                          <div style={{ padding: "1%" }}>
                            <div
                              id={`errorMsg_${index}`}
                              className="error-colorCode"
                              style={{ padding: "0px" }}
                            ></div>
                            <span id={`classNameLabelSection${index}`}>
                              <span className="pText">Class Name</span>
                              <br />
                              <span
                                className="iconText"
                                id={`labelClassNameValue${index}`}
                              >
                                {classObj.className}
                              </span>
                            </span>
                            {classObj.classDescription !== "" ? <br /> : null}
                            <span
                              className="display-none"
                              id={`editClassSection${index}`}
                            >
                              <span className="pText">Class Name</span>
                              <br />
                              <span className="iconText">
                                <FormControl
                                  data-testid="edit_class_name"
                                  id={`editClassName${index}`}
                                  aria-label="Class Description"
                                  aria-describedby="basic-addon2"
                                  style={{ height: "40px" }}
                                  defaultValue={classObj.className}
                                />
                              </span>
                              <br />
                              <span className="pText">Class Description</span>
                              <br />
                              <span className="iconText">
                                <FormControl
                                  data-testid="edit_class_description"
                                  id={`editClassDescription${index}`}
                                  aria-label="Class Description"
                                  aria-describedby="basic-addon2"
                                  style={{ height: "40px" }}
                                  defaultValue={classObj.classDescription}
                                />
                              </span>
                            </span>
                            {classObj.classDescription !== "" ? <br /> : null}
                            <span id={`classLabelSection${index}`}>
                              {classObj.classDescription !== "" ? (
                                <span className="pText">Class Description</span>
                              ) : null}
                              {classObj.classDescription !== "" ? <br /> : null}
                              <span
                                className="iconText"
                                id={`labelClassDescription${index}`}
                              >
                                {classObj.classDescription}
                              </span>
                            </span>
                            <span
                              className="pText"
                              id={`labelEnrolledStudents${index}`}
                            >
                              <br /> <br />
                              Enrolled Students: &nbsp;
                              {classObj.studentList !== undefined
                                ? Array.isArray(classObj.studentList)
                                  ? classObj.studentList.length
                                  : 1
                                : 0}
                              <br />
                            </span>
                            {classObj.studentList !== undefined ? (
                              <div id={`classStudentListSection_${index}`}>
                                <span
                                  id={`expandLink_${index}`}
                                  className="fileName expandClassList"
                                  data-toggle="collapse"
                                  href={`#collapseClassList_${index}`}
                                  role="button"
                                  aria-expanded="false"
                                  aria-controls={`collapseClassList_${index}`}
                                  onClick={toggleClassList}
                                >
                                  Expand Class List
                                </span>
                                <div
                                  id={`collapseClassList_${index}`}
                                  className="collapseClassList collapse"
                                >
                                  <div className="card card-body">
                                    <p className="collapsedListCont display-none">
                                      Click a student's name to view individual
                                      Interactive E-Book Question results.
                                    </p>
                                    <p className="collapsedListContInfo display-none">
                                      Students with the connection icon have
                                      elected to share Study Center data with
                                      you.
                                    </p>
                                    <div className="d-flex flex-row row">
                                      {Array.isArray(classObj.studentList) ? (
                                        classObj.studentList.map(
                                          (student, studIndex) => (
                                            <div className="col-lg-3 collapsedStudenEnrolledList">
                                              {
                                                student.combinedFirstNameAndLastNameForSorting
                                              }
                                            </div>
                                          ),
                                        )
                                      ) : (
                                        <div className="col-lg-3 collapsedStudenEnrolledList">
                                          {
                                            classObj.studentList
                                              .combinedFirstNameAndLastNameForSorting
                                          }
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <br />
                            <span className="pText">Class Documents</span>
                            <div>
                              <div id="fileDocs1" className="row">
                                {classObj.fileList &&
                                  classObj.fileList.map((file, index) => (
                                    <div
                                      className="col-lg-3"
                                      classId={classObj.classId}
                                      fileId={file.fileId}
                                    >
                                      <div className="fileDiv">
                                        {EnableEdit == true &&
                                        classId == classObj.classId ? (
                                          <i
                                            data-testid={`delete_file_${classObj.classId}`}
                                            className="fa fa-close cursor-pointer"
                                            role="button"
                                            aria-label="Delete File"
                                            classId={classObj.classId}
                                            fileName={file.fileName}
                                            fileId={file.fileId}
                                            style={{
                                              float: "right",
                                              fontSize: "20px",
                                            }}
                                            onClick={deleteFile}
                                          ></i>
                                        ) : null}
                                        {EnableEdit == true ? (
                                          <i
                                            className="fas fa-file-alt fileIcon"
                                            style={{ top: "10px" }}
                                          ></i>
                                        ) : (
                                          <i className="fas fa-file-alt fileIcon"></i>
                                        )}
                                      </div>
                                      <span className="fileName">
                                        {file.fileName}
                                      </span>
                                    </div>
                                  ))}
                                <div className="col-lg-3">
                                  <div className="addDocs">
                                    <label
                                      htmlFor={`uploadFile_${index + 1}`}
                                      className="fa fa-plus docsPlus"
                                    ></label>
                                  </div>
                                  <input
                                    data-testid={`uploadFile_${index + 1}`}
                                    type="file"
                                    id={`uploadFile_${index + 1}`}
                                    style={{ display: "none" }}
                                    ref={fileInputRefs.current[index]}
                                    index={index + 1}
                                    classId={classObj.classId}
                                    name="file"
                                    onChange={uploadFile}
                                  />
                                  <label
                                    htmlFor={`uploadFile_${index + 1}`}
                                    tabIndex="0"
                                    onKeyPress={(event) =>
                                      handleDocKeyPress(event, index)
                                    }
                                  >
                                    {" "}
                                    <span className="fileName">
                                      Add documents
                                    </span>{" "}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div id="fileDocs" className="row">
                              <div
                                className="display-none"
                                style={{ width: "100%", marginLeft: "3%" }}
                                id={`editableButton${index}`}
                              >
                                <div className="row">
                                  <div className="col-lg-4 p-0">
                                    <Button
                                      variant="outline-secondary"
                                      index={index}
                                      classId={classObj.classId}
                                      onClick={updateClass}
                                      className="enrollButton"
                                    >
                                      Save Changes
                                    </Button>
                                    &nbsp;
                                  </div>
                                  {classObj.studentList === undefined ? (
                                    <div className="col-lg-3">
                                      <Button
                                        variant="outline-secondary"
                                        index={index}
                                        classId={classObj.classId}
                                        onClick={deleteClass}
                                        className="enrollButton"
                                      >
                                        Delete Class
                                      </Button>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            </Tab>
            {bookVO &&
            bookVO.adminStudyFlag &&
            bookVO.adminStudyFlag === "true" ? (
              <Tab eventKey="studyCenter" title="Study Center">
                <div className="pText commonTabInfoTextItalic mTopTwnty">
                  To view Study Center questions and student results,{" "}
                  <a
                    href={
                      `${process.env.PUBLIC_URL}` +
                      "/study/" +
                      props.match.params.isbn
                    }
                  >
                    {" "}
                    visit the Study Center
                  </a>
                  .
                </div>
              </Tab>
            ) : null}
          </Tabs>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}
export default withAuth(withRouter(ProfessorInsights));
